import { LicenseInfo } from "@mui/x-license";
import "@osp-silver/movex-ui/dist/assets/font/font.css";
import "@osp-silver/movex-ui/dist/assets/fontawesome/css/brands.min.css";
import "@osp-silver/movex-ui/dist/assets/fontawesome/css/duotone-regular.min.css";
import "@osp-silver/movex-ui/dist/assets/fontawesome/css/duotone.min.css";
import "@osp-silver/movex-ui/dist/assets/fontawesome/css/fontawesome.min.css";
import "@osp-silver/movex-ui/dist/assets/fontawesome/css/regular.min.css";
import "@osp-silver/movex-ui/dist/assets/fontawesome/css/solid.min.css";
import "@osp-silver/movex-ui/dist/assets/style/loading-placeholder.css";
import "./styles/fonts.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { CookiesProvider } from "react-cookie";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/query-client.ts";
import { ChunkErrorBoundary } from "./components/ChunkErrorBoundary.tsx";
import { AuthProvider } from "./contexts/auth/AuthProvider.tsx";
import { SnackbarStackProvider } from "./components/SnackbarProvider/snackbar-stack-provider.tsx";
import { router } from "./routes/routes.tsx";
import "@mdi/font/css/materialdesignicons.css";
import "./i18n.ts";
import { AICV_THEME as theme } from "@osp-silver/movex-ui";

const { VITE_MUI_PRO_LICENSE } = import.meta.env;
const MUI_PRO_LICENSE = VITE_MUI_PRO_LICENSE || "";
LicenseInfo.setLicenseKey(MUI_PRO_LICENSE);

const rootElement = document.getElementById("root");

/**
 * 2. Mount Application
 * With the Nginx Proxy setup, we no longer need initApp() or wait logic.
 * The application can mount immediately.
 */
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <ChunkErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <CookiesProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <AuthProvider>
                <SnackbarStackProvider>
                  <RouterProvider router={router} />
                </SnackbarStackProvider>
              </AuthProvider>
            </ThemeProvider>
          </CookiesProvider>
        </QueryClientProvider>
      </ChunkErrorBoundary>
    </StrictMode>,
  );
}
